export const EMAIL_ID_REQURIED = 'Email address is required.';
export const EMAIL_ID_VALID = 'Email address is not valid.';
export const EMAIL_ID_MAX_VALID = 'Email must be at most 255 characters.';
export const PASSWORD_REQURIED = 'Password is required.';
export const PASSWORD_VALID = 'Password is not valid.';
export const CURRENT_PASSWORD_REQURIED = 'Current password is required.';
export const CURRENT_PASSWORD_VALID = 'Current password is not valid.';
export const PASSWORD_INCLUDE_VALID = 'Password must include upper, lower, number & special character.';
export const NEW_AND_CURRENT_PASSWORD_VALID = 'New Password must be different from Current Password.';
export const NEW_PASSWORD_REQURIED = 'New password is required.';
export const COFIRM_PASSWORD_REQURIED = 'Confirm password is required.';
export const PASSWORD_MATCH_REQURIED = 'New password and Re-Enter password must match.';
export const RE_ENTER_PASSWORD_REQURIED = 'Re-Enter password is required.';
export const FIRST_NAME_REQURIED = 'First name is required.';
export const FIRST_NAME_ALPHABET = 'First name can only contain alphabets.';
export const FIRST_NAME_MAX_VALID = 'First name must be at most 255 characters.';
export const LAST_NAME_REQURIED = 'Last name is required.';
export const LAST_NAME_ALPHABET = 'Last name can only contain alphabets.';
export const LAST_NAME_MAX_VALID = 'Last name must be at most 255 characters.';
export const SPECILIZATION_REQURIED = 'Specilization is required.';
export const SPECILIZATION_VALID = 'Specialization is not valid.';
export const PHONE_NUMBER_REQURIED = 'Phone number is required.';
export const PHONE_NUMBER_MAX_REQURIED = 'Phone number must be 10 digits.';
export const PHONE_NUMBER_VALID = 'Phone number must be a number.';
export const COUNTRY_REQURIED = 'Country is required.';
export const STATE_REQURIED = 'State is required.';
export const CITY_REQURIED = 'City is required.';
export const CITY_MAX_VALID = 'City name must be at most 255 characters.';
export const ZIP_CODE_REQURIED = 'ZIP code is required.';
export const ZIP_CODE_VALID = 'ZIP code must be a number.';
export const PAYPAL_EMAIL_ID_REQURIED = 'Paypal email address is required.';
export const PAYPAL_EMAIL_ID_VALID = 'Paypal email address is not valid.';
export const PAYPAL_EMAIL_ID_MAX_VALID = 'PayPal email must be at most 255 characters.';
export const UPLOAD_IMAGE_FILE_VALID = 'Please upload a PNG, JPEG, or GIF image.';
export const UPLOAD_IMAGE_SIZE_VALID = 'File size must be less than 10MB.';
export const TERMS_AND_CONDITIONS_VALID = 'You must agree to the terms and conditions.';
export const SPEAKER_REQURIED = 'Speaker Name is required.';
export const RATE_TRANSCRIPT_REQURIED = 'Rate transcript is required.';
export const RATING_EXPLANATION_REQURIED = 'Rating explanation is required.';
export const REWORK_NOTES_REQURIED = 'Rework notes is required.';
export const UNCLAIM_REASON_REQURIED = 'Details about the issue are required.';
export const UNCLAIM_REASON_MAX_REQURIED = 'Unclaim reason text must be at most 255 characters.';
